/**
 * 使用语言参数
 * @return {object} { lang: number, langText: string }
 */
export function useLang() {
    const {
        lang: langPlugin
    } = window.FEGORender?.plugins || window.FEGOEditor?.plugins;

    const lang = langPlugin.getFegoLang();
    const langText = langPlugin.getFegoLangText();

    return {
        lang,
        langText
    };
}
